import { inject, Injectable } from '@angular/core';

import { KeyValueIsPrimary } from '@models/common';
import { HttpService } from '@shared/services';

export type TemplateDefinitionRequestParams = {
  moduleId: number;
  screenId?: number;
  contractId?: number;
  typeName: string;
};

@Injectable({
  providedIn: 'root',
})
export class TemplateDefinitionService {
  private http = inject(HttpService);

  getUserTemplatesDict({ contractId, moduleId, screenId, typeName }: TemplateDefinitionRequestParams) {
    const params = this.http.buildHttpParams({ contractId, screenId, typeName });
    const headers = moduleId ? { moduleId: moduleId.toString() } : undefined;
    return this.http.get<KeyValueIsPrimary<number>[]>('_api/TemplateDefinition/UserTemplatesDict', {
      httpOptions: { params, headers },
      useLoader: false,
    });
  }

  getTemplatePreview(templateId: number, contractId: number, body: any) {
    const params = this.http.buildHttpParams({ id: templateId, contractId });
    return this.http.post<{ content: string; subject: string }>('_api/TemplateDefinition/PreviewTemplate', body, {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
